import React from 'react';
import { Modal } from '@components/ModalComponents';
import ImportDriversModalContent from '@features/drivers/components/ImportDriversModalContent';

interface ImportDriversModalProps {
  open: boolean;
  onClose: (didImport?: boolean) => void;
}

const ImportDriversModal: React.FC<ImportDriversModalProps> = ({ open, onClose }) => {
  const handleClose = (didImport = false) => {
    if (onClose) onClose(didImport);
  };

  return (
    <Modal open={open} width='md'>
      {open ? <ImportDriversModalContent onClose={handleClose} /> : null}
    </Modal>
  );
};

export default ImportDriversModal;
